export default __webpack_public_path__ + "static/media/twitter-icon.77b6fde2.png";